import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Card, Col, Form, Row, Alert } from "react-bootstrap";
import { useAuth } from "../contexts/AuthContext";
import bg1 from "../assets/img/african-american-young-patient-with-protective-face-mask-against-covid-resting-bed.jpg";
import logo from "../assets/img/cnamgs_cover.jpeg";

import { EyeSlash, Eye } from "react-bootstrap-icons";

export default function Signin2() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { login, user } = useAuth();
  const navigate = useNavigate();

  // 🔥 REDIRECTION SI DEJA CONNECTÉ
useEffect(() => {
  if (user?.role) {
    navigate(`/${user.role}/accueil`, { replace: true });
  }
}, [user, navigate]);
  // Utilisateurs mockés
  const mockUsers = {
    "patient@cnamgs.ga": {
      email: "patient@cnamgs.ga",
      password: "patient123",
      name: "Jean Dupont",
      role: "patient",
      id: "CNAMGS-PAT-001",
      coverage: "80%",
    },
    "doctor@cnamgs.ga": {
      email: "doctor@cnamgs.ga",
      password: "doctor123",
      name: "Dr. Nzogho",
      role: "doctor",
      id: "CNAMGS-DOC-001",
      specialization: "Médecin généraliste",
    },
    "pharmacist@cnamgs.ga": {
      email: "pharmacist@cnamgs.ga",
      password: "pharmacy123",
      name: "Pharmacie Centrale",
      role: "pharmacist",
      id: "CNAMGS-PH-001",
      pharmacyName: "Pharmacie Centrale",
    },
    "admin@cnamgs.ga": {
      email: "admin@cnamgs.ga",
      password: "admin123",
      name: "Admin CNAMGS",
      role: "admin",
      id: "CNAMGS-ADMIN-001",
      level: "super",
    },
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    setTimeout(() => {
      const user = mockUsers[email];

      if (user && password === user.password) {
        login(user);
        // navigate(`/${user.role}/accueil`);
      } else {
        setError("Email ou mot de passe incorrect");
      }

      setLoading(false);
    }, 500);
  };

  // 🔥 OPTION: éviter flash UI
  if (user) return null;

  return (
    <div className="page-sign d-block py-0">
      <Row className="g-0">
        <Col md="7" lg="5" xl="4" className="col-wrapper">
          <Card className="card-sign border-0 shadow-lg rounded-4 overflow-hidden">
            
            <Card.Header className="bg-white border-0 text-center pt-5 pb-2">
              <img
                src={logo}
                alt="CNAMGS"
                style={{ height: "70px", marginBottom: "20px" }}
              />
              <Card.Title className="mt-2 fs-2 fw-bold text-success">
                Connexion
              </Card.Title>
              <Card.Text className="text-muted small">
                Bienvenue ! Connectez-vous pour accéder à votre espace.
              </Card.Text>
            </Card.Header>

            <Card.Body className="px-4 pb-4 bg-white">
              {error && (
                <Alert variant="danger" className="mb-3 rounded-pill">
                  {error}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                {/* EMAIL */}
                <div className="mb-3">
                  <Form.Label className="fw-semibold">
                    Adresse email
                  </Form.Label>
                  <div className="input-group">
                    <span className="input-group-text bg-light border-0 rounded-start-pill">
                      <i className="ri-mail-line"></i>
                    </span>
                    <Form.Control
                      type="email"
                      placeholder="Entrez votre email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      className="rounded-end-pill py-2 px-3 border-0 bg-light"
                    />
                  </div>
                </div>

                {/* PASSWORD */}
                <div className="mb-4">
                  <Form.Label className="fw-semibold">
                    Mot de passe
                  </Form.Label>

                  <div className="input-group">
                    <span className="input-group-text bg-light border-0 rounded-start-pill">
                      <i className="ri-lock-line"></i>
                    </span>

                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="Mot de passe"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      className="py-2 px-3 border-0 bg-light"
                    />

                    <button
                      type="button"
                      className="input-group-text bg-light border-0 rounded-end-pill"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <EyeSlash /> : <Eye />}
                    </button>
                  </div>
                </div>

                {/* BUTTON */}
                <Button
                  type="submit"
                  className="w-100 rounded-pill py-2 fw-bold bg-success"
                  disabled={loading}
                >
                  {loading ? "Connexion..." : "Se connecter"}
                </Button>
              </Form>
            </Card.Body>

            <Card.Footer className="bg-white border-0 text-center pb-4">
              <small className="text-muted">
                © 2025 CNAMGS Digital
              </small>
            </Card.Footer>

          </Card>
        </Col>

        {/* IMAGE */}
        <Col className="d-none d-lg-block p-0">
          <img
            src={bg1}
            alt="CNAMGS"
            style={{
              width: "100%",
              height: "100vh",
              objectFit: "cover",
            }}
          />
        </Col>
      </Row>
    </div>
  );
}